import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownPanelProps {
  showScarcity?: boolean;
}
export function CountdownPanel({
  showScarcity = true
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="mx-auto w-full max-w-narrow text-center" data-id="element-50" data-mp="l8ry9ed3afu0">
      <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-blue-700 md:text-base" data-id="element-51" data-mp="q6tezsn1m32b">
        <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="c8bx4bjtjksb" />
        Precio de lanzamiento — cierra en:
      </p>

      <div className="mt-6 flex items-start justify-center gap-4 md:gap-8" role="timer" data-id="element-53" data-mp="26k0e0j9m1xfc">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-54" data-mp="2bjd217c7xaji">
            <span className="font-display text-5xl font-extrabold tabular-nums leading-none tracking-tight text-blue-600 md:text-7xl" data-id="element-55" data-mp="1lh6wnypyyhsb">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-900/55" data-id="element-56" data-mp="1hdip3g1c7m72">
              {unit.label}
            </span>
          </div>)}
      </div>

      {showScarcity && <div className="mt-8" data-id="element-57" data-mp="1qa9j7mwbwqz0">
          <p className="inline-flex items-center gap-2 rounded-xl bg-alert-50 px-4 py-2.5 text-sm font-semibold text-alert-600 ring-1 ring-alert-100 md:text-base" data-id="element-58" data-mp="12ht2pgs8p71t">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="yj3r9tqrhzkt" />
            Después sube $6.000 ARS. No vuelve.
          </p>

          <div className="mt-7" data-id="element-60" data-mp="17gw3gp16sr3z">
            <div className="flex items-baseline justify-between text-sm font-semibold text-blue-900/70" data-id="element-61" data-mp="17fujfv270ua4">
              <span data-id="element-62" data-mp="2ntufguxx3zs3">Cupos al precio de lanzamiento</span>
              <span data-id="element-63" data-mp="2ix43ojt5bqch">Quedan pocos</span>
            </div>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-blue-100" data-id="element-64" data-mp="2iyoubyccap52">
              <div className="h-full w-[68%] rounded-full bg-blue-600" data-id="element-65" data-mp="2qx0mk7x9ykxm" />
            </div>
            <p className="mt-2 text-right text-xs text-blue-900/55" data-id="element-66" data-mp="2uxasjkl2hbch">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>}
    </div>;
}